import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface UseUpdateResolution886AssessmentParams {
	assessment_id: string;
	organization_id: string;
	company_id: string;
	review_id: string;
	activity_id: string;
}

const Service = Resolution886ReportService.getInstance();

export function useUpdateResolution886Assessment() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UseUpdateResolution886AssessmentParams) => Service.updateAssessment(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_ASSESSMENT]);
		},
		onError: () => {
			message.error(I18n.get('Error updating assessment'));
		}
	});
}
